// extracted by mini-css-extract-plugin
module.exports = {"background":"style_background__3S-V4","title":"style_title__2vhnB","glass":"style_glass__3zLc-"};